<template>
    <button class=
    "border-[.5px] rounded-lg border-[rgba(38,38,38,.5)]
    justify-center items-center 
    font-medium
    sm:p-2.5 sm:w-[179px] sm:h-[52px] min-h-[38px] p-1 mt-6 ml-6
    transition-colors duration-200
    hover:bg-primary-100
    "
    :class="[modelValue ? 'bg-primary-200' : 'bg-[#EEF1F6]']"
    @click="$emit('update:modelValue', !modelValue)"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue']
}
</script>